import React from 'react'
import { Svg } from './Svg'

export function Info(props): React.JSX.Element {
    return (
        <Svg fill="currentColor" {...props} viewBox="0 0 256 256">
            <circle cx="128" cy="128" fill="none" r="96" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
            <polyline fill="none" points="120 120 128 120 128 176 136 176" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
            <circle cx="126" cy="84" r="12"/>
        </Svg>
    )
}

// Phosphor+user